import {Sport1MaterialTabs} from "../components/material-tabs";
import {WPApi} from "../common/wp-api";
import {share} from "../article/social";
import "../common/jquery-functions";

const api = new WPApi();

jQuery(document).ready(async function ($) {


    const tabs = new Sport1MaterialTabs('.material-tabs');


    tabs._onTabClick = (e, $activeTab) => {
        let contentSelector = $activeTab.get(0).hash;
        let content = $(`${contentSelector} .vod-slider-items`);
        const categoryId = $activeTab.attr('id');
        let category = $activeTab.text().trim();
        sport1Analytics.sendEvent('vod-page', 'slider-tab-click', category);

        if (!$activeTab.attr('data-loaded')) {
            $activeTab.attr('data-loaded', true);
            // noinspection JSIgnoredPromiseFromCall
            loadCategoryData(content, categoryId);
        }
        return false;
    };

    let $sliders = $('.vod-slider-items');

    $sliders.on('scroll', function () {
        const $sliderPrevButton = $('.vod-slider-nav-prev', $(this).parent());
        const $sliderNextButton = $('.vod-slider-nav-next', $(this).parent());

        let scrollLeft = $(this).scrollLeft();

        if (scrollLeft === 0) {
            $sliderPrevButton.removeClass('active');
            $sliderNextButton.addClass('active');
        } else {
            $sliderPrevButton.addClass('active');
        }

        if (this.scrollWidth - (Math.abs(scrollLeft) + 1256) === 0) {
            $sliderNextButton.removeClass('active');
        } else {
            $sliderNextButton.addClass('active');
        }

    });


    $sliders.each(function () {
        updateSliderNavigation.call(this);
    });

    $('.vod-featured .social-icon').on('click', function (e) {
        e.preventDefault();
        let medium = $(this).attr('id');
        let $post = $('.vod-featured .image-container .post-link');
        let link = $post.attr('href');
        let title = $('.vod-featured .item-title a').text();
        link = `${window.location.host}${link}`;
        sport1Analytics.sendEvent('vod-page', 'share-click', medium);
        share(link, medium, title);
    });

    $('.vod-featured .post-link').on('click', function () {
        sport1Analytics.sendEvent('vod-page', 'game-play', 'main game');
    });

    $('.slider-item .post-link').on('click', function () {
        let $slider = $(this).closest('.vod-slider');
        let category = $('.sport1-show-more', $slider).attr('href');
        if (!category) {
            category = 'hot-videos';
        }
        sport1Analytics.sendEvent('vod-page', 'brief-click', category);
    });


    $('.sport1-show-more').on('click', function () {
        let category = $(this).attr('href');
        sport1Analytics.sendEvent('vod-page', 'slider-all-videos-click', category);
    });

});


function updateSliderNavigation() {
    if (1260 < this.scrollWidth) {

        const $sliderPrevButton = $('.vod-slider-nav-prev', $(this).parent());
        const $sliderNextButton = $('.vod-slider-nav-next', $(this).parent());

        const itemTitleHeight = $('.item-title', this).height();

        $sliderPrevButton.css('padding-bottom', itemTitleHeight);
        $sliderNextButton.css('padding-bottom', itemTitleHeight);

        $sliderNextButton.addClass('active');
        $sliderNextButton.on('click', () => {
            let scrollBy = $('.vod-slider-item').outerWidth();
            this.scrollBy({left: -scrollBy, behavior: 'smooth'})
        });

        $sliderPrevButton.on('click', () => {
            let scrollBy = $('.vod-slider-item').outerWidth();
            this.scrollBy({left: scrollBy, behavior: 'smooth'})
        })
    }
}

async function loadCategoryData($tabContent, categoryId) {

    $tabContent.loader(true);
    let categorySliderHtml = await api.get(`wp/v2/vod/videos/${categoryId}?html=true&posts_per_page=20`);
    $tabContent.loader(false);
    const $vodCategorySlider = $(`#vod-category-tab-${categoryId} .vod-slider-items`);
    $('.vod-slider-items-wrapper', $vodCategorySlider).remove();
    $vodCategorySlider.prepend(categorySliderHtml);

    $tabContent.attr('data-loaded', true);
    lazyLoader.update();
    updateSliderNavigation.call($vodCategorySlider.get(0));
}
